<template>
  <b-card v-if="item">
    <b-row>
      <b-col>
        <b-tabs content-class="mt-3">
          <b-tab :title="$t('views.profile.index.tabs.info')">
            <b-row>
              <b-col>
                <p>{{ $t('views.profile.index.info.name') }}: <b>{{ item.name }}</b></p>
                <p>{{ $t('views.profile.index.info.surname') }}: <b>{{ item.surname }}</b></p>
                <p>{{ $t('views.profile.index.info.mobilePhone') }}: <b><phoneNumberLink :phoneNumber="item.mobilePhone"/></b></p>
                <p>{{ $t('views.profile.index.info.userEmail') }}: <b><a :href="'mailto: ' + item.userEmail"> {{ item.userEmail }}</a></b></p>
              </b-col>
              <b-col cols="4">
                <AvatarDisplay v-model="avatarChanged" :item="item"></AvatarDisplay>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-btn class="btn btn-sm btn-success mt-0" @click="editProfile()">{{ $t('buttons.edit') }}</b-btn>
                <b-btn class="btn btn-sm btn-warning mt-0" @click="$bvModal.show('changePasswordModal')">{{ $t('buttons.changePassword') }}</b-btn>
              </b-col>
            </b-row>
          </b-tab>
          <!--<b-tab :title="$t('views.profile.index.tabs.configuration')">-->
            <!--configuration-->
          <!--</b-tab>-->
        </b-tabs>
      </b-col>
    </b-row>
    <EditProfileModal></EditProfileModal>
    <ChangePasswordModal></ChangePasswordModal>
  </b-card>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import VueCookie from 'vue-cookie'
import EditProfileModal from './UserProfile/EditProfileModal'
import AvatarDisplay from '../userdata/component/AvatarDisplay/AvatarDisplay'
import ChangePasswordModal from './UserProfile/ChangePasswordModal'
import PhoneNumberLink from '@/components/Dashboard/Views/firm/components/PhoneNumberLink'

export default {
  components: {
    PhoneNumberLink,
    EditProfileModal,
    AvatarDisplay,
    ChangePasswordModal
  },

  computed: mapGetters({
    deleteError: 'userdata/del/error',
    error: 'userdata/show/error',
    isLoading: 'userdata/show/isLoading',
    item: 'userdata/show/retrieved'
  }),

  data () {
    return {
      nameAndSurname: '',
      avatarChanged: 0
    }
  },

  watch: {
    avatarChanged: function () {
      if (this.avatarChanged === 1) {
        this.avatarChanged = 0
        this.retrieve(decodeURIComponent('user_datas/' + VueCookie.get('user_data_id')))
      }
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.nameAndSurname = VueCookie.get('name') + ' ' + VueCookie.get('surname')
    this.retrieve(decodeURIComponent('user_datas/' + VueCookie.get('user_data_id')))
    this.itemPusher = this.$store.state.Pusher.subscribe('user_datas-' + VueCookie.get('user_data_id'))
    this.itemPusher.bind('user_datas-' + VueCookie.get('user_data_id'), data => {
      this.retrieve(decodeURIComponent('user_datas/' + VueCookie.get('user_data_id')))
    })
  },

  destroyed () {
    this.$store.state.Pusher.unsubscribe('user_datas-' + VueCookie.get('user_data_id'))
  },

  methods: {
    ...mapActions({
      del: 'userdata/del/del',
      reset: 'userdata/show/reset',
      retrieve: 'userdata/show/retrieve'
    }),

    editProfile () {
      this.$store.state.modals.profile.update.userdataObject = this.item
      this.$store.state.modals.profile.update.show = 1
    },

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'UserDataList' }))
      }
    }
  }
}
</script>
